import {gsap} from 'gsap'
import {GSDevTools} from 'gsap/GSDevTools.js'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import {SplitText} from 'gsap/SplitText.js'
import Swiper from 'swiper'
import {Autoplay,EffectFade,Pagination,Thumbs} from 'swiper/modules'

gsap.registerPlugin(ScrollTrigger,SplitText,GSDevTools)
ScrollTrigger.config({
  autoRefreshEvents: 'load,DOMContentLoaded' // notice there's no "resize"
})
  ; (function($) {
    'use strict'

    var Home = {
      init: function() {
        this.heroAnimation()

        document.fonts.ready.then(() => {
          this.aboutSetup()
        })
        this.productValuesSetup()
        this.sliderPartners()
        this.portfolioSetup()

        if($('.section-homepage-testimonial').length > 0) {
          this.testimonialSetup()
        }

        this.discoverySetup()

        if($('.section-homepage-news').length > 0) {
          this.newsSetup()
        }
      },

      // Hero Animation
      heroAnimation: function() {
        const $section = $('.section-hero-homepage')
        if(!$section.length) return // Kiểm tra nhanh nếu section không tồn tại

        const shape1 = $section.find('.shape-1')
        const shape2 = $section.find('.shape-2')
        const text1 = $section.find('.text-1 h2')
        const text2 = $section.find('.text-2 h2')
        const desc = $section.find('.desc')
        const cta = $section.find('.cta-holder')

        // Common setup for all screen sizes
        gsap.set([shape1,shape2,text1,text2,desc,cta],{autoAlpha: 0})
        gsap.set([shape1,shape2],{
          xPercent: -50,
          yPercent: -50,
          transformOrigin: 'center center'
        })

        function startSwapTextAnimation() {
          ;['.inner.text-1','.inner.text-2'].forEach(function(selector) {
            const $h2s = $(selector + ' h2')
            $h2s.not(':first').hide()
            gsap.set($h2s.first(),{y: 0,opacity: 1})

            const tl = gsap.timeline({repeat: -1,repeatDelay: 0.5})

            $h2s.each(function(i) {
              const $current = $(this)
              const $next = $h2s.eq((i + 1) % $h2s.length)

              tl.to($current,{
                y: -20,
                opacity: 0,
                duration: 0.8,
                onComplete: () => {
                  $current.hide()
                  $next.show()
                  gsap.set($next,{y: 20,opacity: 0})
                }
              })
                .to($next,{y: 0,opacity: 1,duration: 0.8})
                .to({},{duration: 2})
            })
          })
        }

        // Main animation timeline
        const tl = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power3.out'
          },
          onComplete: () => {
            startSwapTextAnimation()
          }
        })

        tl.fromTo(shape1,{yPercent: -100,autoAlpha: 0},{yPercent: -50,autoAlpha: 1,duration: 1.5})
          .to(shape1,{xPercent: -38.14,autoAlpha: 1,duration: 0.5})
          .to(shape2,{xPercent: -68.46,autoAlpha: 1,duration: 0.5},'-=0.5')
          .fromTo([text1,text2],{y: 20},{y: 0,autoAlpha: 1,duration: 1})
          .fromTo([desc,cta],{y: 20},{y: 0,autoAlpha: 1},'-=1')

        // GSDevTools.create({ animation: tl })

        return () => {
          mainTl.kill() // Cleanup timeline
        }
      },

      // Reveal Text
      aboutSetup: function() {
        const $revealText = $('.reveal-text')
        if(!$revealText.length) return

        // Dùng SplitText lên từng <p>, gom tất cả words lại
        const allWords = []
        const splitInstances = []

        $revealText.find('p').each(function() {
          const $p = $(this)
          const split = new SplitText($p[0],{
            type: 'words',
            wordsClass: 'word++'
          })

          splitInstances.push(split)
          allWords.push(...split.words)
        })

        // Set trạng thái ban đầu cho tất cả từ
        gsap.set(allWords,{
          opacity: 0.3,
          display: 'inline-block',
          whiteSpace: 'nowrap'
        })

        // Dùng 1 timeline cho toàn bộ từ
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: '.section-about',
            start: 'top 60%',
            end: 'bottom bottom',
            scrub: 1,
            invalidateOnRefresh: true,
            toggleActions: 'play none none reverse'
          }
        })

        tl.to(allWords,{
          opacity: 1,
          duration: 2.5,
          ease: 'power2.out',
          stagger: 0.4
        })

        // Cleanup nếu cần
        return () => {
          splitInstances.forEach((split) => split.revert())
          tl.kill()
        }
      },

      // Product Values Setup
      productValuesSetup: function() {
        const $productList = $('.product-list')
        if(!$productList.length) {
          return
        }

        const swiper = new Swiper($productList[0],{
          modules: [Autoplay,EffectFade,Pagination],
          // direction: 'vertical',
          effect: 'fade',
          fadeEffect: {crossFade: true},
          slidesPerView: 1,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: false
          },
          allowTouchMove: false,
          touchStartPreventDefault: false,
          loop: true,
          speed: 800,
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // },
          breakpoints: {
            // 769: {
            //   pagination: { enabled: false }
            // }
          }
        })

        const mm = gsap.matchMedia()
        let tl = null

        mm.add(
          {
            isSmallTablet: '(max-width: 768px)',
            isTablet: '(min-width: 769px)'
          },
          (context) => {
            const {isSmallTablet} = context.conditions

            function animateAttrs($slide) {
              const $attrs = $slide.find('.attr')
              if(!$attrs.length) return

              tl = gsap.timeline()

              if(isSmallTablet) {
                tl.fromTo(
                  $attrs.filter(':nth-child(1), :nth-child(2)'),
                  {opacity: 0,y: 20,x: 0},
                  {opacity: 1,y: '-100%',stagger: 1,duration: 0.5,ease: 'power2.out'}
                ).fromTo(
                  $attrs.filter(':nth-child(3), :nth-child(4)'),
                  {opacity: 0,y: 20,x: 0},
                  {opacity: 1,y: 0,delay: 0.5,stagger: 1,duration: 0.5,ease: 'power2.out'}
                )
              } else {
                tl.fromTo(
                  $attrs,
                  {opacity: 0,y: 20},
                  {opacity: 1,y: '-50%',stagger: 1,duration: 0.5,ease: 'power2.out'}
                )
              }

              // GSDevTools.create({ animation: tl })
            }

            function resetAttrs($slide) {
              const $attrs = $slide.find('.attr')
              gsap.set($attrs,{opacity: 0,y: 20,clearProps: 'all'})
            }

            animateAttrs($('.swiper-slide-active'))

            swiper.on('slideChangeTransitionStart',() => {
              resetAttrs($('.swiper-slide'))
            })

            swiper.on('slideChangeTransitionEnd',() => {
              animateAttrs($('.swiper-slide-active'))
            })

            return () => {
              swiper.destroy(true,true)
            }
          }
        )
      },

      // Discovery Setup
      discoverySetup: function() {
        const $section = $('.section-discovery')
        const $sectionLeftCol = $section.find('.left-col')
        const $scrollEl = $section.find('.right-col')
        if(!$section.length || !$scrollEl.length) return

        const mm = gsap.matchMedia()

        mm.add(
          {
            isTablet: '(max-width: 1024px)',
            isDesktop: '(min-width: 1025px)'
          },
          (context) => {
            const {isTablet} = context.conditions

            if(isTablet) {
              const swiper = new Swiper('.discovery-image-slider',{
                modules: [Autoplay,Pagination],
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                freeMode: true,
                speed: 800,
                autoplay: {
                  delay: 1500,
                  disableOnInteraction: true,
                  pauseOnMouseEnter: true
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                }
              })

              return () => {
                swiper.destroy(true,true)
              }
            } else {
              const sectionH = $section.outerHeight()
              const contentH = $scrollEl.outerHeight()
              const scrollDist = sectionH + (sectionH - $sectionLeftCol.outerHeight()) - contentH

              if(scrollDist <= 0) return

              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: $section[0],
                  start: 'top top',
                  end: `+=${scrollDist}`,
                  scrub: true,
                  pin: true,
                  pinSpacing: false,
                  invalidateOnRefresh: true,
                  // markers: true,
                }
              });

              tl.to($scrollEl,{
                y: -scrollDist,
                ease: 'none',
              })

              return () => {
                tl.kill()
              }
            }
          }
        )
      },

      // Slider Partners
      sliderPartners: function() {
        const $track = $('.partner-track')
        const $items = $track.find('.partner-item')
        if(!$track.length || !$items.length) return

        const mm = gsap.matchMedia()

        mm.add(
          {
            isMobile: '(max-width: 768px)',
            isDesktop: '(min-width: 769px)'
          },
          (context) => {
            const {isMobile} = context.conditions

            $items.each(function() {
              const $clone = $(this).clone()
              $track.append($clone)
            })

            const totalWidth = $track[0].scrollWidth / 2

            const marqueeTl = gsap.to($track,{
              x: -totalWidth,
              duration: isMobile ? 15 : 20,
              ease: 'none',
              repeat: -1,
              modifiers: {
                x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth)
              }
            })

            const $marquee = $track.closest('.partner-marquee')
            $marquee.on('mouseenter',() => marqueeTl.pause()).on('mouseleave',() => marqueeTl.resume())

            return () => {
              marqueeTl.kill()
              $marquee.off('mouseenter mouseleave')
              $track.find('.partner-item').slice($items.length).remove()
            }
          }
        )
      },

      // Portfolio Setup
      portfolioSetup: function() {
        const $section = $('.section-portfolio')
        const $layout = $section.find('.section-layout')
        const $heading = $section.find('.section-heading')
        const panels = gsap.utils.toArray('.brand-item')

        if(!$section.length || !$layout.length || !$heading.length || !panels.length) return

        // Cleanup trigger cũ nếu có
        if(this._portfolioTriggers) {
          this._portfolioTriggers.forEach((trigger) => trigger.kill())
        }

        // Tính toán chiều cao layout
        const triggerHeight =
          $heading.outerHeight() + parseInt($layout.css('padding-top')) + parseInt($heading.css('margin-bottom'))

        const triggers = []

        // Pin từng panel
        panels.forEach((panel,i) => {
          const st = ScrollTrigger.create({
            trigger: panel,
            endTrigger: panels[panels.length - 1],
            start: `top top+=${triggerHeight}`,
            end: `top top+=${triggerHeight}`,
            pin: true,
            pinSpacing: false,
            id: `panel-${i}`,
            invalidateOnRefresh: true
          })
          triggers.push(st)
        })

        // Pin heading
        const headingTrigger = ScrollTrigger.create({
          trigger: $layout[0],
          endTrigger: panels[panels.length - 1],
          start: 'top top',
          end: `top top+=${triggerHeight}`,
          pin: $heading[0],
          pinSpacing: false,
          invalidateOnRefresh: true
        })
        triggers.push(headingTrigger)

        this._portfolioTriggers = triggers

        // Thêm ScrollTrigger.refresh() khi resize
        if(!this._resizeHandler) {
          this._resizeHandler = () => {
            ScrollTrigger.refresh()
          }
          window.addEventListener('resize',this._resizeHandler)
        }
      },

      // Testimonial
      testimonialSetup: function() {
        const logoBrandSwiper = new Swiper('.logo-brand-slider',{
          modules: [Thumbs],
          speed: 600,
          loop: true,
          spaceBetween: '0',
          slideToClickedSlide: true,
          slidesPerView: 'auto',
          centeredSlides: false,
          allowTouchMove: true,
          grabCursor: true,
          updateOnWindowResize: true,
          breakpoints: {
            0: {
              centeredSlides: true
            },
            678: {
              centeredSlides: false
            }
          }
        })

        const testimonialSwiper = new Swiper('.testimonial-slider',{
          modules: [Autoplay,Thumbs,EffectFade],
          effect: 'fade',
          fadeEffect: {crossFade: true},
          speed: 600,
          // autoplay: {
          //   delay: 3000,
          //   disableOnInteraction: false,
          //   pauseOnMouseEnter: true
          // },
          loop: true,
          allowTouchMove: false,
          grabCursor: false,
          thumbs: {
            swiper: logoBrandSwiper
          }
        })

        // Cleanup nếu dùng trong component (optional)
        return () => {
          logoBrandSwiper.destroy(true,true)
          testimonialSwiper.destroy(true,true)
        }
      },

      // News Setup
      newsSetup: function() {
        const $section = $('.section-homepage-news')
        const $slider = $section.find('.news-slider')

        const swiper = new Swiper($slider[0],{
          modules: [Autoplay],
          loop: true,
          spaceBetween: 16,
          slidesPerView: 1.3,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true // Add pause on hover
          },
          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 12
            },
            768: {
              slidesPerView: 'auto',
              centeredSlides: true,
              spaceBetween: 0
            }
          }
        })

        return () => {
          swiper.destroy(true,true) // Add cleanup
        }
      }
    }

    // Initialize when DOM is ready
    $(function() {
      if($('#page-home').length > 0) {
        Home.init()
      }
    })
  })(jQuery)
